import React, {Component} from 'react';
import {Input, Grid} from 'react-spreadsheet-grid';
import set from 'lodash.set';
import {Collapse} from 'react-collapse';
import Select, {components, DropdownIndicatorProps} from 'react-select';
import {Button} from "react-bootstrap";
import arrow_up from "../../assets/icons/dark_arrow_up.png";
import arrow_down from "../../assets/icons/dark_arrow_down.png";
import del from '../../assets/icons/del.png'
import add from '../../assets/icons/add.png'
import {Typography} from "@material-ui/core";
import { IMaskInput } from "react-imask";


export class FieldsTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            columns: [],
            columnsRegion: [],
            isAreaRight: true,
        };
    }


    componentDidMount() {
        this.populateFieldsData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.field !== this.props.field) {
            this.checkSumArea();
        }
    }

    addRowRegion = (rowId) => {
        fetch('api/region?fieldId=' + rowId, {
            method: 'POST',
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`},
        }).then((response) => {
            if (response.ok) {
                response.json().then((result) => {
                    let row = this.props.field.find((row) => {
                        return row.id === rowId;
                    });
                    row.regions = row.regions.concat(result)
                    this.props.onFieldChange();
                })
            }
        });
    }

    removeRowRegion = (rowId) => {
        fetch('api/region?id=' + rowId, {
            method: 'DELETE',
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
        }).then((response) => {
            if (response.ok) {
                response.json().then((result) => {
                    let row = this.props.field.find((row) => {
                        return row.id === result;
                    });
                    row.regions = row.regions.filter(e => e.id !== rowId)
                    this.props.onFieldChange();
                    this.checkSumArea()
                })
            }
        });
    }

    static renderTable(columns, rows, addRow, columnsRegion, expand, isExpand, isReport) {
        const tableField = rows ? rows.map((row) => (
                <>
                    <div id="main_field_table">
                        <Grid
                            rowHeight={75}
                            columns={columns}
                            rows={[row]}
                            focusOnSingleClick={true}
                            getRowKey={row => row.id}
                            isScrollable={false}
                            disabledCellChecker={(row, columnId) => {
                                return columnId === 'name'
                            }}
                        />
                        <div id="error-label">Площадь поля не совпадает с суммой площади участков</div>
                    </div>
                    <div className="label-btn-container">
                        <Button className="label-button" onClick={expand}>
                            Почвенные показатели по последнему туру обследования
                            <img src={isExpand ? arrow_up : arrow_down} className='btn-arrow' alt='arrow'/>
                        </Button>
                    </div>
                    <Collapse isOpened={isExpand}>
                        <div id="main_regions_table">
                            <Grid
                                columns={columnsRegion}
                                rowHeight={88}
                                rows={row.regions}
                                focusOnSingleClick={true}
                                getRowKey={row => row.id}
                                isScrollable={false}
                                disabledCellChecker={(row, columnId) => {
                                    return columnId === 'soilId' || columnId === 'button_remove' || columnId==='dateAnalyse';
                                }}
                            />
                        </div>
                        {!isReport?
                        <div className="add-btn-container">
                            <button className="btn add-btn" onClick={() => addRow(row.id)}><img src={add} alt='add'/>
                            </button>
                        </div>:<></>}
                    </Collapse>
                </>
            )
        ) : []

        return (<>{tableField}</>);
    }


    render() {
        return (
            FieldsTable.renderTable(
                this.state.columns,
                this.props.field,
                this.addRowRegion,
                this.state.columnsRegion,
                this.props.changeExpand,
                this.props.expand,
                this.props.isReport)
        );

    }

    checkSumArea = () => {
        let sum_area = 0
        if (this.props.field && this.props.field.length !== 0) {
            // eslint-disable-next-line array-callback-return
            this.props.field[0].regions.map((region) => {
                sum_area += Number(region.area);
            })
            if (sum_area !== Number(this.props.field[0].area)) {
                this.setState({isAreaRight: false}, () => {
                    document.getElementById("field-area").className = "area-input";
                    document.getElementById('error-label').className = 'error-label'
                });
            } else {
                this.setState({isAreaRight: true}, () => {
                    document.getElementById("field-area").className = "area-input-true";
                    document.getElementById('error-label').className = 'no-error-label'
                });
                return true
            }
        }

    }

    async populateFieldsData() {
        const numberFormat = new Intl.NumberFormat('ru-RU')

        function formatCell(value) {
            return value ? numberFormat.format(value.toString().replace(',', '.')).replace(',', '.') : 0
        }

        const soils_list = this.props.soil_list;
        this.checkSumArea();
        const onFieldChange = (rowId, field) => (value1) => {
            let value = Number(value1.replace(/\s/g, "").replace(',', '.'))
            const modifiedRows = [].concat(this.props.field);
            const row = modifiedRows.find((row) => {
                return row.id === rowId;
            });
            set(row, field, value);
            this.checkSumArea();
            this.props.onFieldChange()
        }
        const onDateChange=(rowId, value)=>{
            const rowRegion = this.props.field[0].regions.find((row) => {
                return row.id === rowId;
            });
            set(rowRegion, 'dateAnalyse', value);
            this.props.onFieldChange();
        }
        const onRegionChange = (rowId, field) => (value1) => {
            let value = (field === 'dateAnalyse' || field === 'name') ? value1 : Number(value1.replace(/\s/g, "").replace(',', '.'))
            const rowRegion = this.props.field[0].regions.find((row) => {
                return row.id === rowId;
            });
            set(rowRegion, field, value);
            this.checkSumArea();
            this.props.onFieldChange();
        }
        const onSelectChange = (rowId, field) => (value) => {
            const rowRegion = this.props.field[0].regions.find((row) => {
                return row.id === rowId;
            });
            rowRegion.soil = this.props.soil.find((s) => {
                return s.id === value.value;

            })
            set(rowRegion, field, value.value);
            this.checkSumArea();
            this.props.onFieldChange();
        }
        const onSelectFieldChange = (rowId, field) => (value) => {
            const modifiedRows = [].concat(this.props.field);
            const row = modifiedRows.find((row) => {
                return row.id === rowId;
            });
            set(row, field, value.value);
            this.props.changeField(value.value)
        }

        const DropdownIndicator = (props: DropdownIndicatorProps<ColourOption, true>) => {
            return (
                <components.DropdownIndicator {...props}>
                    <img src={props.selectProps.menuIsOpen ? arrow_up : arrow_down} alt='arrow-down'
                         className='arrow'></img>
                </components.DropdownIndicator>
            );
        };

        function NoOptionsMessage(props) {
            if (props.options.length) return null;
            return <Typography className='no-options-label' {...props.innerProps}>Нет данных</Typography>;
        }

        const del_button = (id) => {
            return (<button className="btn delete-row-btn"
                            onClick={() => this.removeRowRegion(id)}><img src={del} alt='del'/></button>)
        }
        const columns = [
            {
                title: 'Наименование поля',
                value: (row, {focus}) => {
                    return (this.props.isReport?
                            <Input
                                value={row.name}
                                focus={focus}
                            />:
                        <Select
                            className='in-table-select'
                            maxMenuHeight='230px'
                            options={this.props.fields_name}
                            components={{DropdownIndicator, NoOptionsMessage}}
                            theme={(theme) => ({
                                ...theme,
                                border: '1px solid #ABB3D1',
                                borderRadius: '10px',
                                colors: {
                                    ...theme.colors,
                                    primary: '#ABB3D1',
                                },
                            })}
                            styles={{
                                container: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: '95%',
                                    height: '52px',
                                }),
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    background: state.isFocused ? '#fff' : '#E9EAEE',
                                    height: '52px',
                                    width: '100%',
                                }),
                                menu: (baseStyles, state) => ({
                                    ...baseStyles,
                                    border: ' 1px solid #ABB3D1',
                                    borderRadius: '10px',
                                    margin: '0',
                                }),
                                option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    height: '45px',
                                    backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                }),
                                menuList: (baseStyles, state) => ({
                                    ...baseStyles,
                                    paddingRight: '13px !important',
                                    "::-webkit-scrollbar":{
                                        width: '3px !important'
                                    },
                                    "::-webkit-scrollbar-track": {
                                        background: '#E2E4EF !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb":{
                                        background: ' #ABB3D1 !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb:hover":{
                                        background: ' #ABB3D1 !important',
                                    }
                                })
                            }}
                            defaultValue={this.props.fields_name.find((r) => r.label === row.name)}
                            onChange={onSelectFieldChange()}
                        />
                    )
                },
                id: 'name',
                getCellClassName: () => this.props.isReport?'':"SpreadsheetGrid__cell_focused"
            }, {
                title: 'Площадь, га',
                value: (row, {focus}) => {
                    return (
                        <div id="field-area">
                            {/* eslint-disable-next-line eqeqeq */}
                            <div className={row.area == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.area)}
                                    selectTextOnFocus={true}
                                    focus={focus}
                                    onChange={onFieldChange(row.id, 'area')}
                                />
                            </div>
                        </div>
                    );
                },
                id: 'area',
            }
        ]

        const columnsRegion = [
            {
                title: 'Дата анализа',
                value: (row, {focus}) => {
                    return (
                        <IMaskInput
                            className='date-input'
                            mask={Date}
                            value={row.dateAnalyse}
                            min={new Date(2000, 0, 1)}
                            max={new Date(2050, 0, 1)}
                            onAccept={(value, mask) => onDateChange(row.id, value)}
                            placeholder="00.00.0000"
                        />
                    );
                },
                id: 'dateAnalyse',
                width: 9,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }, {
                title: 'Наим.\nэл. уч.',
                value: (row, {focus}) => {
                    return (
                        <Input
                            placeholder='0'
                            value={row.name}
                            selectTextOnFocus={true}
                            focus={focus}
                            onChange={onRegionChange(row.id, 'name')}
                        />
                    );
                },
                id: 'name',
                width: 7,
            }, {
                title: 'Площадь, га',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.area == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.area)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'area')}
                            />
                        </div>
                    );
                },
                id: 'area',
                width: 8,
            }, {
                title: 'Тип почвы',
                value: (row, {focus}) => {
                    return (
                        <Select
                            className='in-table-select'
                            maxMenuHeight='244px'
                            components={{DropdownIndicator, NoOptionsMessage}}
                            theme={(theme) => ({
                                ...theme,
                                border: '1px solid #ABB3D1',
                                borderRadius: '10px',
                                colors: {
                                    ...theme.colors,
                                    primary: '#ABB3D1',
                                },
                            })}
                            styles={{
                                container: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: '90%',
                                    height: '70px',
                                }),
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    background: state.isFocused ? '#fff' : '#E9EAEE',
                                    height: '70px',
                                    width: '100%',
                                }),
                                menu: (baseStyles, state) => ({
                                    ...baseStyles,
                                    border: ' 1px solid #ABB3D1',
                                    borderRadius: '10px',
                                    margin: '0'
                                }),
                                option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                    height: '80px',
                                    lineHeight: '20px'
                                }),
                                singleValue: (baseSyles) => ({
                                    ...baseSyles,
                                    whiteSpace: 'normal',
                                    height: '60px',
                                    display: 'flex',
                                    alignContent: 'center',
                                    alignItems:'center',
                                    verticalAlign: 'middle',
                                    textAlign: 'left',
                                    lineHeight: '18px'
                                }),
                                menuList: (baseStyles, state) => ({
                                    ...baseStyles,
                                    paddingRight: '13px !important',
                                    "::-webkit-scrollbar":{
                                        width: '3px !important'
                                    },
                                    "::-webkit-scrollbar-track": {
                                        background: '#E2E4EF !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb":{
                                        background: ' #ABB3D1 !important',
                                        borderRadius: '6px !important'
                                    },
                                    "::-webkit-scrollbar-thumb:hover":{
                                        background: ' #ABB3D1 !important',
                                    }
                                })

                            }}
                            options={soils_list}
                            defaultValue={soils_list[soils_list.findIndex((r) => r.value === row.soilId)]}
                            onChange={onSelectChange(row.id, 'soilId')}
                        />
                    );
                },
                id: 'soilId',
                width: 28,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }, {
                title: 'Гумус,\n%',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.humus == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.humus)}
                                selectTextOnFocus={true}
                                focus={focus}
                                onChange={onRegionChange(row.id, 'humus')}
                            />
                        </div>
                    );
                },
                id: 'humus',
                width: 6,
            }, {
                title: 'pH',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.pH == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.pH)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'pH')}
                            />
                        </div>
                    );
                },
                id: 'pH',
                width: 6,
            }, {
                title: 'N,\nкг/га',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.element.n == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.element.n)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'element.n')}
                            />
                        </div>
                    );
                },
                id: 'N',
                width: 6,
            }, {
                title: 'P₂O₅,\nкг/га',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.element.p2O5 == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.element.p2O5)}
                                selectTextOnFocus={true}
                                focus={focus}
                                onChange={onRegionChange(row.id, 'element.p2O5')}
                            />
                        </div>
                    );
                },
                id: 'P2O5',
                width: 6,
            }, {
                title: 'K₂O,\nкг/га',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.element.k2O == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.element.k2O)}
                                selectTextOnFocus={true}
                                focus={focus}
                                onChange={onRegionChange(row.id, 'element.k2O')}
                            />
                        </div>
                    );
                },
                id: 'K2O',
                width: 6,
            }, {
                title: 'S,\nкг/га',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.element.s == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.element.s)}
                                selectTextOnFocus={true}
                                focus={focus}
                                onChange={onRegionChange(row.id, 'element.s')}
                            />
                        </div>
                    );
                },
                id: 'S',
                width: 6,
            }, {
                title: 'CaO,\nкг/га',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.element.caO == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.element.caO)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'element.caO')}
                            />
                        </div>
                    );
                },
                id: 'caO',
                width: 6,
            }, {
                title: 'Mg,\nкг/га',
                value: (row, {focus}) => {
                    return (
                        // eslint-disable-next-line eqeqeq
                        <div className={row.element.mg == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.element.mg)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'element.mg')}
                            />
                        </div>
                    );
                },
                id: 'mg',
                width: 5.9,
            }, {
                title: '',
                value: (row) => {
                    return this.props.isReport?<></>:del_button(row.id);
                },
                id: 'button_remove',
                width: 0,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }
        ]

        this.setState({columns: columns, columnsRegion: columnsRegion});
    }

}
